import {
  all, call, fork, put, takeEvery,
} from 'redux-saga/effects';

// action creators
import { doneIndicator, error } from '../../actions/httpActions';

// api
import { patch } from '../../sources/api/client';
import noteService from '../../sources/api/noteService';

// constants
import {
  NOTE_TAG_BULK_REMOVE,
  NOTE_TAG_BULK_REMOVE_INIT,
} from '../../constants/noteTypes';

// lib
import httpSaga from '../../lib/httpSaga';

export function* noteTagBulkRemove(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const { pnm, tag, chapter } = action.payload || {};

  const options = {
    query: {
      chapter,
      pnm,
      tagToRemove: tag,
    },
  };

  const removeTagFromNotes = async () => {
    const notes = await patch(noteService, null, {}, options);
    return { pnm, tag, notes };
  };

  try {
    yield* httpSaga(NOTE_TAG_BULK_REMOVE, call(removeTagFromNotes));
  } catch (err) {
    yield put(error(NOTE_TAG_BULK_REMOVE, err));
  } finally {
    yield put(doneIndicator(NOTE_TAG_BULK_REMOVE));
  }
}

export function* watchNoteTagBulkRemove() {
  yield takeEvery(NOTE_TAG_BULK_REMOVE_INIT, noteTagBulkRemove);
}

export default function* root() {
  yield all([fork(watchNoteTagBulkRemove)]);
}
